import { serverResponse } from "../fakeServer"

export const strings = {
    "saveBtnTooltip": serverResponse.config.send_grocery_list_to_market ? "Aggiungi al carrello" : "Aggiungi alla lista",
    "deleteAllBtnTooltip": serverResponse.config.send_grocery_list_to_market ? "Svuota carrello" : "Cancella la lista",
    "deleteBtnTooltip": serverResponse.config.send_grocery_list_to_market ? "Elimina dal carrello" : "Elimina dalla lista",
    // "relatedProductsTitle": "Guarda anche:",
    "relatedProductsTitle": "ALTRE VARIANTI",
}